const INITIAL_STATE = {
  fases: [],
  resumo: [],
  medicoes: { controlador_id: null, fase_id: null, horas: 24, medicoes: [] },
  baseline: { horas: [] },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'TRAFEGO_FASES_FETCHED':
      return { ...state, fases: action.payload.data };
    case 'TRAFEGO_RESUMO_FETCHED':
      return { ...state, resumo: action.payload.data };
    case 'TRAFEGO_MEDICOES_FETCHED':
      return { ...state, medicoes: action.payload.data };
    case 'TRAFEGO_BASELINE_FETCHED':
      return { ...state, baseline: action.payload.data };
    default:
      return state;
  }
};
